import { StyleSheet, Text, View, Image } from 'react-native'
import React from 'react'

const WelcomeFourth = () => {
  return (
    // <>
    //   <Text
    //     style={{
    //       fontWeight: 'bold',
    //       fontSize: 27,
    //       color: 'white',
    //       alignSelf: 'center'
    //     }}
    //   >
    //     Your Earnings
    //   </Text>

    //   <Text
    //     style={{
    //       fontSize: 17,
    //       color: 'white',
    //       alignSelf: 'center',
    //       marginTop: '5%'
    //     }}
    //   >
    //     You will be able to see earnings on a
    //   </Text>
    //   <Text style={{ fontSize: 17, color: 'white', alignSelf: 'center' }}>
    //     daily basis.
    //   </Text>

    //   <View style={[styles.rectangle]}>
    //     <Image
    //       source={require('../../../static/images/Welcome-Earnings.png')}
    //       style={[styles.appBrand]}
    //       resizeMode="contain"
    //     />
    //   </View>
    // </>
    <>
      {/* <Text
     style={{
       fontWeight: 'bold',
       fontSize: 27,
       color: 'white',
       alignSelf: 'center'
     }}
   >
     Your Earnings
   </Text>
      <Text
     style={{
       fontSize: 17,
       color: 'white',
       alignSelf: 'center',
    
     }}
   >
     You will be able to see earnings on a daily basis.
   </Text>
       <Image
       source={require('../../../static/images/Welcome-Earnings.png')}
       style={[styles.appBrand]}
       resizeMode="contain"
     /> */}

      <Text
        style={{
          fontWeight: 'bold',
          fontSize: 27,
          color: 'white',
          alignSelf: 'center'
        }}
      > Change Password</Text>

      <Image
        source={require('../../../static/images/Welcome-PasswordChange.png')}
        style={[styles.appBrand]}
        resizeMode="contain"
      />
    </>
  )
}

export default WelcomeFourth

const styles = StyleSheet.create({
  rectangle: {
    alignSelf: 'center',
    marginTop: '20%',
    width: '30%',
    height: '64%',
    // backgroundColor: 'white',
    borderRadius: 15
  },
  appBrand: {
    width: '50%',
    height: '70%',
    alignSelf: 'center'
    // marginTop:'10%'
  }
})
